export default "__VITE_ASSET__sKoPk$62__"